import fr from './fr';
import en from './en';
import es from './es';
import de from './de';
import ar from './ar';
import { ILanguages } from '../../interface';

export default { fr, en, es, de, ar } as ILanguages;
